// components/common/modal/ModalActions.tsx
import React from 'react';
import { Button, ButtonProps, DialogActions, DialogActionsProps, styled } from '@mui/material';

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
    padding: theme.spacing(1.5, 2.5),
    justifyContent: 'space-between',
}));

interface ModalActionsProps extends DialogActionsProps {
    children?: React.ReactNode;
    onCancel?: () => void;
    onSubmit?: (e?: React.SyntheticEvent) => void;
    cancelText?: string;
    submitText?: string;
    submitDisabled?: boolean;
    cancelButtonProps?: ButtonProps;
    submitButtonProps?: ButtonProps;
}

export const ModalActions = ({
    children,
    onCancel,
    onSubmit,
    cancelText = 'Cancel',
    submitText = 'Save',
    submitDisabled = false,
    cancelButtonProps = {},
    submitButtonProps = {},
    ...props
}: ModalActionsProps) => {
    if (children) {
        return <StyledDialogActions {...props}>{children}</StyledDialogActions>;
    }

    return (
        <StyledDialogActions {...props}>
            <Button
                variant="outlined"
                onClick={onCancel}
                sx={{
                    fontWeight: 500,
                    textTransform: 'none',
                    color: 'text.primary',
                    borderColor: 'divider',
                    '&:hover': {
                        borderColor: 'text.secondary',
                        backgroundColor: 'action.hover',
                    },
                }}
                {...cancelButtonProps}
            >
                {cancelText}
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={onSubmit}
                disabled={submitDisabled}
                sx={{
                    px: 3,
                    py: 1,
                    fontWeight: 600,
                    textTransform: 'none',
                    borderRadius: 1.5,
                    '&.Mui-disabled': {
                        backgroundColor: 'action.disabledBackground',
                        color: 'text.disabled',
                    },
                }}
                {...submitButtonProps}
            >
                {submitText}
            </Button>
        </StyledDialogActions>
    );
};
